import { EMPTY_OBJECT, EMPTY_STRING } from '../../../constants/common'
import { SearchSectionHeader } from '../SearchSectionHeader'

import * as styles from './SearchSection.module.css'

/**
 * @import {SearchSectionHeaderProps} from "../SearchSectionHeader/SearchSectionHeader"
 * @import {SearchSectionContentProps} from "../SearchSectionContent/SearchSectionContent"
 */

/**
 * @public
 * @typedef {object} SearchSectionProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<SearchSectionContentProps>} [Content]
 *
 * @property {React.ComponentType<SearchSectionHeaderProps>} [Header]
 *
 * @property {React.ReactNode} [childreen]
 *
 * @property {string} [className]
 *
 * @property {SearchSectionContentProps} [contentProps]
 *
 * @property {React.ReactNode} [header]
 *
 * @property {SearchSectionHeaderProps} [headerProps]
 *
 * @property {React.ReactNode} [title]
 */

/**
 * @param {SearchSectionProps} props
 */
function SearchSection({
  Element = 'section',
  Header = SearchSectionHeader,
  children,
  className = styles.SearchSection,
  headerProps: {
    className: headerClassName = styles.header,
    ...headerProps
  } = EMPTY_OBJECT,
  title = EMPTY_STRING,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      {title && Header ? (
        <Header {...headerProps} className={headerClassName} title={title} />
      ) : null}
      {children}
    </Element>
  )
}

export default SearchSection
